import React, {Fragment, useState} from 'react';
import {Translate} from "../../../lang/lang";
import {useSelector} from "react-redux";
import {selectLang} from "../../../store/reducers/main/main";
import IconButton from "../../IconButton";
import {faTelegram} from "@fortawesome/free-brands-svg-icons";
import {Button, Card, Modal} from "react-bootstrap";
import FalconCloseButton from "../../common/FalconCloseButton";

const NotificationTelegramModal = () => {
    const [show, setShow] = useState(false);
    const t = Translate
    const lang = useSelector(selectLang)

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    return (
        <Fragment>
            <IconButton
                variant="phoenix-secondary"
                size={"sm"}
                icon={faTelegram}
                iconClassName="fs-7 text-primary-davr align-middle"
                className={'btn-davr bg-white text-dark gap-2'}
                transform="shrink-3"
                onClick={handleShow}
            >
                {t(lang, "notification.table.telegram.settings")}
            </IconButton>

            <Modal show={show} className={"davr-modal"} onHide={handleClose} backdrop="static" keyboard={false}>
                <Modal.Header className="d-flex align-items justify-content-between">
                    <Modal.Title className="fs-0 m-0 fw-bold">{t(lang, "notification.table.telegram_bot.modal.title")}</Modal.Title>
                    <FalconCloseButton className={'bg-white m-0 btn-davr-modal-close'} onClick={() => handleClose()}/>
                </Modal.Header>
                <Modal.Body>
                    <Card className={"p-1"}>
                        <p className="mb-2">1. {t(lang, "notification.table.telegram_bot.instructions.click_button")} - <b>"{t(lang, "notification.table.telegram_bot.instructions.send_notification")}"</b>
                        </p>
                        <p className="mb-2">2. {t(lang, "notification.table.telegram_bot.instructions.open_app")} - <b>"Telegram"</b>
                        </p>
                        <p className="mb-2">3. {t(lang, "notification.table.telegram_bot.instructions.run_bot")} - <b>"/start"</b>
                        </p>
                        <p className="mb-2">4. {t(lang, "notification.table.telegram_bot.instructions.click_button")} - <b>"{t(lang, "notification.table.telegram_bot.instructions.send_phone")}"</b>
                        </p>
                    </Card>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="phoenix-secondary"
                            iconClassName="fs-7 text-primary-davr align-middle"
                            className={'btn-davr bg-white text-dark gap-2'}
                            size={"sm"} onClick={handleClose}>
                        {t(lang, "notification.close_button")}
                    </Button>
                    <IconButton className={"btn-davr px-3 py-0 bg-primary-davr"} variant="primary" icon={faTelegram} transform="shrink-3" size={"sm"}
                                iconClassName={"fs-7 align-middle"}
                                href="https://t.me/HippoNotificationBot" onClick={handleClose} target="_blank">
                        {t(lang, "notification.table.telegram_bot.modal.send")}
                    </IconButton>
                </Modal.Footer>
            </Modal>
        </Fragment>
    );
};

export default NotificationTelegramModal;
